
import { IconMixins } from "@/mixins/IconMixins";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import vSelect3 from "vselect3";
import GenericUpdateModal from '@/components/table/generic-update-modal.vue';

const { base64Encode } = IconMixins.methods

@Component({
	components: {
		"v-select-3": vSelect3,
		"generic-update-modal": GenericUpdateModal,
	}
})

export default class IconUpload extends Vue {
	$refs!: {
		GenericUpdateModal: GenericUpdateModal;
	}

	@Prop({ required: false }) private customFieldId: string;
	@Prop({ required: false }) private model: any;
	@Prop({ required: false, default: false }) private readonly: boolean;
	@Prop({ required: false, default: false }) private useAltModelSearch: boolean;

	private file1: File = null;
	private imageSrc: any = null;
	private selectedIconType: string = "File Upload"
	private validImage: boolean | null = null;
	private feedbackMessage: string = "";
	private readonly iconTypes: string[] = ["File Upload", "URL", "Font Awesome"];
	private readonly fileUploadType: string = "File Upload";
	private readonly urlType: string = "URL";
	private readonly fontAwesomeType: string = "Font Awesome";
	private readonly acceptedFileTypes: string[] = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
	private readonly maxFileSizeInBytes: number = 1000000;
	private readonly invalidFileTypeMessage: string = "Invalid File Type";
	private readonly invalidFileSizeMessage: string = "File exceeds 1MB size limit";

	private mounted(): void {
		if (this.customFieldValue && this.customFieldValue.startsWith("data")) {
			this.selectedIconType = this.fileUploadType;
			this.imageSrc = this.customFieldValue;
		}

		if (this.customFieldValue && this.customFieldValue.toLowerCase().startsWith("http")) {
			this.selectedIconType = this.urlType;
			this.imageSrc = this.customFieldValue;
		}

		if (this.customFieldValue && this.customFieldValue.toLowerCase().startsWith("fa")) {
			this.selectedIconType = this.fontAwesomeType;
			this.imageSrc = this.customFieldValue;
		}
	}

	private get previewIconClass(): string {
		return `mt-1 ${this.imageSrc}`
	}

	private isFileValid (file: File): boolean {
		if (!this.acceptedFileTypes.includes(file.type)) {
			this.validImage = false;
			this.feedbackMessage = this.invalidFileTypeMessage;
			return this.validImage;
		}

		if (file.size > this.maxFileSizeInBytes) {
			this.validImage = false;
			this.feedbackMessage = this.invalidFileSizeMessage;
			return this.validImage;
		}

		this.validImage = true;

		return this.validImage;
	}

	private onIconTypeChange(): void {
		this.clearIcon()
		this.validImage = null;
	}

	private clearIcon(): void {
		this.file1 = null;
		this.imageSrc = null;
	}

	@Watch("file1")
	private async configureIcon(newValue, oldValue): Promise<void> {
		if (newValue && newValue !== oldValue && this.isFileValid(newValue)) {
			try {
				this.imageSrc = await base64Encode(newValue);
			}
			catch(err) {
				this.clearIcon();
			}
		}
		else {
			this.clearIcon();
		}
	}

	@Watch("imageSrc")
	private onImageSrcChange(): void {
		this.$emit("input", this.imageSrc);
	}

	private get customFieldValue(): string {
		if (this.useAltModelSearch) {
			return this.model;
		}
		else{
			return this.model["cf" + this.customFieldId];
		}
	}
}
